import { Extension } from '@tiptap/core'
import { Plugin } from '@tiptap/pm/state'
import { Decoration, DecorationSet } from 'prosemirror-view';
import { Node } from '@tiptap/pm/model';

function findTodos(doc: Node) {
    const decorations: Decoration[] = [];

    doc.descendants((node, pos) => {
        if (!node.text) {
            return
        }
        
        Array.from(node.text.matchAll(/\bTODO\b/g)).forEach(match => {
            const from = pos + (match.index || 0);
            const to = from + match[0].length;

            decorations.push(
                Decoration.inline(from, to, {
                    class: 'highlight',
                })
            );
        });
    });

    return DecorationSet.create(doc, decorations);
}

export const EditorHighlighter = Extension.create({
    name: 'editorHighlighter',

    addProseMirrorPlugins() {
        return [
            new Plugin({
                state: {
                    init(_, { doc }) {
                        return findTodos(doc)
                    },
                    apply(transaction, oldState) {
                        return transaction.docChanged ? findTodos(transaction.doc) : oldState
                    },
                },
                props: {
                    decorations(state) {
                        return this.getState(state);
                    },
                },
            }),
        ]
    },
})
